import { graphql } from "react-relay";

export const delete_enrolment = graphql`
  mutation DeleteEnrolmentMutation($connections: [ID!]!, $input: DeleteEnrolmentInput!) {
    deleteEnrolment(input: $input) {
      success
      errors
      deletedEnrolmentId @deleteEdge(connections: $connections)
      updatedEnrolmentsInWaitingList {
        id
        positionInWaitingList
      }
    }
  }
`;
